import React from "react";
import { cover } from "polished";
import styled, { css } from "styled-components";
var ArrowSvg = function ArrowSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9 0 7.414 1.586l6.277 6.289H0v2.25h13.691l-6.277 6.289L9 18l9-9-9-9Z"
  }));
};
ArrowSvg.defaultProps = {
  width: "18",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MinusSvg = function MinusSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M.5.167h15v2.142H.5V.167Z"
  }));
};
MinusSvg.defaultProps = {
  width: "16",
  height: "3",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var PlusSvg = function PlusSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6.929 6.929V.5H9.07v6.429H15.5V9.07H9.071V15.5H6.93V9.071H.5V6.93h6.429Z"
  }));
};
PlusSvg.defaultProps = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import breakpoint from "../../../utils/breakpoint";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import { getCustomColor } from "../../../utils/getCustomColor";
import getTextColor from "../../../utils/getTextColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import ButtonAtm from "../../atoms/ButtonAtm";
import BreakpointVisibilityOrg from "../../organisms/BreakpointVisibilityOrg";
import FlexItemOrg from "../../organisms/FlexItemOrg";
import LinkQuark from "../../quarks/Link";
export var largeBreakpointValue = "large";
export var Wrapper = styled.div.withConfig({
  componentId: "sc-1a7jsrp-0"
})(function (_ref) {
  var $backgroundColor = _ref.$backgroundColor,
    $customColor = _ref.$customColor,
    $showImage = _ref.$showImage,
    theme = _ref.theme;
  return css(["position:relative;height:100%;background:", ";", "{border-radius:", ";box-shadow:", ";", "}"], $customColor ? getCustomColor($customColor) : getColor(theme, $backgroundColor), breakpoint(largeBreakpointValue), getBorderRadius(theme, "large"), getBoxShadow(theme, "medium"), $showImage && css(["border-bottom-left-radius:0;border-bottom-right-radius:0;"]));
});
export var HoverImageWrapper = styled.div.withConfig({
  componentId: "sc-1a7jsrp-1"
})(function (_ref2) {
  var theme = _ref2.theme;
  return css(["display:none;position:absolute;bottom:-", ";left:0;width:100%;img{width:100%;height:", ";object-fit:cover;border-bottom-right-radius:", ";border-bottom-left-radius:", ";box-shadow:", ";}"], unit(120), unit(120), getBorderRadius(theme, "large"), getBorderRadius(theme, "large"), getBoxShadow(theme, "medium"));
});
export var ContentWrapper = styled.div.withConfig({
  componentId: "sc-1a7jsrp-2"
})(function (_ref3) {
  var $showImage = _ref3.$showImage;
  return css(["", "{display:flex;flex-direction:column;height:100%;", ";}"], breakpoint(largeBreakpointValue), $showImage && css(["", "{display:block;}"], HoverImageWrapper));
});
export var StyledFlexItem = styled(FlexItemOrg).withConfig({
  componentId: "sc-1a7jsrp-3"
})(["", "{padding:", " ", " ", " ", ";}", "{padding:", " ", " ", " ", ";}"], breakpoint(largeBreakpointValue), space(2), space(2), space(0), space(2), breakpoint("huge"), space(4), space(4), space(0), space(4));
export var HeaderContainer = styled.div.withConfig({
  componentId: "sc-1a7jsrp-4"
})(["display:flex;align-items:center;justify-content:space-between;cursor:pointer;", "{cursor:inherit;}"], breakpoint(largeBreakpointValue));
export var Link = styled(LinkQuark).withConfig({
  componentId: "sc-1a7jsrp-5"
})(["display:block;color:inherit;text-decoration:none;&::before{", ";content:\"\";z-index:1;}"], cover());
export var TextContainer = styled.div.withConfig({
  componentId: "sc-1a7jsrp-6"
})(["margin-top:", ";"], space(2));
export var StyledMobileButton = styled(ButtonAtm).withConfig({
  componentId: "sc-1a7jsrp-7"
})(["margin-top:", ";", "{display:none;}"], space(3), breakpoint(largeBreakpointValue));
export var IconWrapper = styled.div.withConfig({
  componentId: "sc-1a7jsrp-8"
})(["", "{display:none;}"], breakpoint(largeBreakpointValue));
export var Footer = styled.div.withConfig({
  componentId: "sc-1a7jsrp-9"
})(function (_ref4) {
  var $hasArrow = _ref4.$hasArrow;
  return css(["display:none;", "{display:block;padding:", " ", ";", "}"], breakpoint(largeBreakpointValue), space(3), space(4), $hasArrow && css(["display:flex;align-items:flex-end;justify-content:end;"]));
});
export var DesktopButton = styled(ButtonAtm).withConfig({
  componentId: "sc-1a7jsrp-10"
})(["display:none;", "{display:inline-flex;&::before{", ";content:\"\";z-index:1;}}"], breakpoint(largeBreakpointValue), cover());
export var StyledBreakpointVisability = styled(BreakpointVisibilityOrg).withConfig({
  componentId: "sc-1a7jsrp-11"
})(["margin:", " 0 0 0;"], space(3));
export var ImageWrapper = styled.div.withConfig({
  componentId: "sc-1a7jsrp-12"
})(function (_ref5) {
  var theme = _ref5.theme;
  return css(["img{width:100%;height:100%;object-fit:cover;border-radius:", ";}"], getBorderRadius(theme, "large"));
});
export var StyledArrowSvg = styled(ArrowSvg).withConfig({
  componentId: "sc-1a7jsrp-13"
})(function (_ref6) {
  var theme = _ref6.theme,
    $onColor = _ref6.$onColor;
  return css(["fill:", ";"], getTextColor(theme, $onColor));
});
export var StyledPlusSvg = styled(PlusSvg).withConfig({
  componentId: "sc-1a7jsrp-14"
})(function (_ref7) {
  var theme = _ref7.theme,
    $onColor = _ref7.$onColor;
  return css(["fill:", ";"], getTextColor(theme, $onColor));
});
export var StyledMinusSvg = styled(MinusSvg).withConfig({
  componentId: "sc-1a7jsrp-15"
})(function (_ref8) {
  var theme = _ref8.theme,
    $onColor = _ref8.$onColor;
  return css(["fill:", ";"], getTextColor(theme, $onColor));
});